import { createContext, useContext, useState } from "react";

const WA_NUMBER = "6282282800020";
export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const translations = {
  id: {
    nav: {
      products: "Produk",
      catalog: "Katalog",
      advantages: "Keunggulan",
      calculator: "Kalkulator",
      keywords: "Kata Kunci",
      location: "Lokasi",
      blog: "Artikel",
      cta: "Hubungi WhatsApp",
    },
    hero: {
      eyebrow: "CV. SINAR AL MUBAROKAH — CILINCING, JAKARTA UTARA",
      lines: ["Pabrik Kayu Jakarta.", "Harga Murah.", "Stok Melimpah."],
      sub: "Distributor kayu olahan langsung dari pabrik — semua jenis & ukuran kayu untuk proyek konstruksi, furniture, dan industri. Pengiriman cepat 24 jam se-Jabodetabek.",
      ctaWa: "Minta Penawaran via WhatsApp",
      ctaCatalog: "Lihat 15 Katalog Produk",
      stats: [
        { value: "35.000+", label: "m³ kapasitas gudang" },
        { value: "24 Jam", label: "pengiriman Jabodetabek" },
        { value: "100%", label: "kayu legal & terukur" },
      ],
      waMsg: "Halo CV. Sinar Al Mubarokah, saya ingin konsultasi kebutuhan kayu dan minta penawaran harga.",
      badge: "Foto fasilitas pabrik kami",
    },
    marquee: [
      "MERANTI KALIMANTAN",
      "KAMPER SAMARINDA",
      "BENGKIRAI EXTRA",
      "MERBAU PAPUA",
      "ULIN SULAWESI",
      "KASO 4x6",
      "BALOK 8x12",
      "PAPAN COR",
      "PLYWOOD MC LENGKAP TIPIS & TEBAL",
      "BEBAS ONGKIR SE-JABODETABEK MIN. 2 M³",
    ],
    advantages: {
      eyebrow: "KENAPA KAMI",
      title: "Langsung dari pabrik, tanpa perantara.",
      sub: "Empat alasan kontraktor dan industri mempercayakan pengadaan kayunya kepada kami.",
      items: [
        { title: "Harga Langsung Pabrik", desc: "Tanpa markup distributor. Harga grosir untuk pembelian ecer maupun partai besar.", big: true },
        { title: "Stok Melimpah", desc: "Gudang 35.000+ m³ di Cilincing — semua jenis & ukuran kayu ready stock." },
        { title: "Custom Ukuran", desc: "Potong ukuran dan jenis sesuai kebutuhan proyek Anda — proses cepat, presisi, toleransi mesin." },
        { title: "Pengiriman 24 Jam", desc: "Armada sendiri untuk Jabodetabek, Banten, Karawang & ekspedisi nasional." },
        { title: "Mutu Terkontrol", desc: "Sortir manual, kadar air terukur (MC <18%), kayu oven tersedia." },
      ],
    },
    catalog: {
      eyebrow: "KATALOG PRODUK",
      title: "15 produk unggulan, siap kirim hari ini.",
      sub: "Semua jenis dan ukuran kayu olahan — klik produk untuk pesan langsung via WhatsApp.",
      filters: { all: "Semua (15)", balok: "Balok & Konstruksi", papan: "Papan & Plywood", reng: "Reng & Kaso", outdoor: "Spesialis Outdoor" },
      labels: { size: "Ukuran", grade: "Mutu", stock: "Stok" },
      ready: "Ready Stock",
      order: "Pesan via WA",
      detail: "Lihat Detail",
      orderMsg: (name, dim) => `Halo CV. Sinar Al Mubarokah, saya ingin memesan *${name}* ukuran ${dim}. Mohon info harga & ketersediaan stok.`,
    },
    keywords: {
      eyebrow: "PUSAT KATA KUNCI PENGADAAN",
      title: "Cari kayu? Kami muncul untuk 10 kata kunci ini.",
      sub: "Klik untuk menyalin kata kunci, atau langsung tanyakan harganya ke WhatsApp kami.",
      copied: "Tersalin!",
      copy: "Salin",
      ask: "Tanya Harga",
      askMsg: (kw) => `Halo CV. Sinar Al Mubarokah, saya mencari "${kw}". Mohon penawaran harga terbaik.`,
      list: [
        "pabrik kayu jakarta murah",
        "distributor kayu olahan cilincing",
        "supplier kayu balok meranti jakarta",
        "jual kayu kamper samarinda grosir",
        "harga kaso 4x6 murah jakarta",
        "agen kayu bengkirai deck jabodetabek",
        "grosir plywood triplek cor jakarta utara",
        "distributor kayu ulin merbau partai besar",
        "tempat beli kayu proyek konstruksi terdekat",
        "custom ukuran kayu industri pallet langsung pabrik",
      ],
    },
    calculator: {
      eyebrow: "KALKULATOR KUBIKASI",
      title: "Hitung kebutuhan kayu Anda dalam hitungan detik.",
      sub: "Masukkan dimensi & jumlah batang — langsung dapat volume m³ dan estimasi harga.",
      thickness: "Tebal (cm)",
      width: "Lebar (cm)",
      length: "Panjang (m)",
      qty: "Jumlah Batang",
      result: "Total Volume / m³",
      estimate: "Estimasi Harga",
      estimateNote: "Kisaran Rp 1.525.000 – 1.850.000 / m³, tergantung jenis & mutu kayu.",
      ref: "Acuan 1 m³: kaso 4x6x4 ≈ 104 batang · balok 6x12x4 ≈ 35 batang",
      send: "Kirim Hitungan ke WhatsApp",
      waMsg: (t, w, l, q, v) => `Halo CV. Sinar Al Mubarokah, saya hitung kebutuhan: ${t}x${w} cm, panjang ${l} m, ${q} batang = ${v} m³. Mohon penawaran harga.`,
      tier: (v) => (v >= 5 ? "Tier Harga: Partai Besar (termurah)" : v >= 1 ? "Tier Harga: Grosir" : "Tier Harga: Ecer Proyek"),
    },
    location: {
      eyebrow: "LOKASI PABRIK & GUDANG",
      title: "Kunjungi langsung pabrik kami di Cilincing.",
      sub: "Tim pengadaan dipersilakan inspeksi fasilitas, cek stok fisik, dan negosiasi langsung di tempat.",
      address: "Jl. Kali Baru Bar. III No.41, RT.2/RW.12, Kali Baru, Kec. Cilincing, Jakarta Utara 14110",
      openMaps: "Buka di Google Maps",
      hours: "Senin – Sabtu, 08.00 – 17.00 WIB",
      fleet: "Radius armada: Jabodetabek • Banten • Karawang • Ekspedisi laut nasional",
    },
    productPage: {
      back: "Kembali ke Katalog",
      gallery: "Galeri Foto Produk",
      spec: "Spesifikasi & Tabel Ukuran",
      size: "Ukuran Tersedia",
      grade: "Mutu / Grade",
      mc: "Kadar Air",
      use: "Kegunaan",
      stock: "Status Stok",
      stockValue: "Ready Stock — Gudang Cilincing",
      minOrder: "Minimal Order",
      order: "Pesan Produk Ini via WhatsApp",
      related: "Produk Terkait",
      slideshowTitle: "Kayu Terlengkap Jakarta",
      guideTitle: "Cara Pemesanan & Pengiriman",
      guideIntro: "Proses pemesanan di CV. Sinar Al Mubarokah dirancang cepat dan transparan untuk kebutuhan proyek Anda:",
      guideSteps: [
        "Kirim kebutuhan Anda via WhatsApp 0822-8280-0020 — sebutkan produk, ukuran, dan jumlah batang/lembar yang dibutuhkan.",
        "Tim kami membalas dengan foto stok aktual, harga terbaru, dan ongkos kirim ke lokasi proyek Anda pada hari yang sama.",
        "Setelah deal, pembayaran bisa via transfer bank atau tunai di gudang. Pengiriman Jabodetabek dilayani armada sendiri dalam 24 jam kerja.",
      ],
      guideNote: "Anda juga dipersilakan datang langsung ke gudang kami di Jl. Kali Baru Bar. III No.41, Kali Baru, Cilincing, Jakarta Utara untuk inspeksi fisik stok dan negosiasi harga partai besar secara langsung.",
    },
    blog: {
      eyebrow: "ARTIKEL & PANDUAN",
      title: "Panduan pengadaan kayu untuk proyek Anda.",
      sub: "Artikel seputar jenis kayu, update harga, dan tips membeli langsung dari pabrik.",
      readMore: "Baca Artikel",
      min: "menit baca",
      back: "Semua Artikel",
      related: "Artikel Lainnya",
      ctaTitle: "Butuh penawaran harga hari ini?",
      ctaSub: "Tim kami fast response — kirim kebutuhan Anda, langsung kami balas dengan harga pabrik.",
      ctaBtn: "Chat WhatsApp Sekarang",
      toc: "Daftar Isi",
      byAuthor: "Ditulis oleh",
    },
    footer: {
      tagline: "Pabrik & distributor kayu olahan Jakarta. Stok melimpah, semua jenis & ukuran, harga langsung pabrik.",
      contact: "Kontak",
      quick: "Navigasi",
      rights: "Hak cipta dilindungi.",
    },
    float: { online: "Online — Chat WhatsApp" },
  },
  en: {
    nav: {
      products: "Products",
      catalog: "Catalog",
      advantages: "Advantages",
      calculator: "Calculator",
      keywords: "Keywords",
      location: "Location",
      blog: "Articles",
      cta: "Chat on WhatsApp",
    },
    hero: {
      eyebrow: "CV. SINAR AL MUBAROKAH — CILINCING, NORTH JAKARTA",
      lines: ["Jakarta Timber Factory.", "Wholesale Prices.", "Massive Stock."],
      sub: "A direct-from-factory processed wood distributor — every wood species & size for construction, furniture and industry. Fast 24-hour delivery across Greater Jakarta.",
      ctaWa: "Get a Quote on WhatsApp",
      ctaCatalog: "Browse 15-Product Catalog",
      stats: [
        { value: "35,000+", label: "m³ warehouse capacity" },
        { value: "24 Hrs", label: "Greater Jakarta delivery" },
        { value: "100%", label: "legal, graded timber" },
      ],
      waMsg: "Hello CV. Sinar Al Mubarokah, I'd like to consult about timber needs and request a price quote.",
      badge: "Our actual factory facility",
    },
    marquee: [
      "KALIMANTAN MERANTI",
      "SAMARINDA CAMPHOR",
      "EXTRA BENGKIRAI",
      "PAPUA MERBAU",
      "SULAWESI IRONWOOD",
      "KASO 4x6",
      "BEAMS 8x12",
      "FORMWORK PLANKS",
      "MC PLYWOOD ALL SIZES THIN & THICK",
      "FREE DELIVERY GREATER JAKARTA MIN. 2 M³",
    ],
    advantages: {
      eyebrow: "WHY US",
      title: "Straight from the factory, no middlemen.",
      sub: "Four reasons contractors and industries trust us with their timber procurement.",
      items: [
        { title: "Direct Factory Pricing", desc: "Zero distributor markup. Wholesale rates for retail and bulk orders alike.", big: true },
        { title: "Abundant Stock", desc: "35,000+ m³ warehouse in Cilincing — every species & size ready to ship." },
        { title: "Custom Sizing", desc: "Cut to the size and species your project needs — fast processing, precise machine tolerance." },
        { title: "24-Hour Delivery", desc: "Own fleet for Greater Jakarta, Banten, Karawang & national freight." },
        { title: "Controlled Quality", desc: "Hand-sorted, measured moisture content (MC <18%), kiln-dried available." },
      ],
    },
    catalog: {
      eyebrow: "PRODUCT CATALOG",
      title: "15 flagship products, ready to ship today.",
      sub: "Every processed wood type and size — click a product to order instantly via WhatsApp.",
      filters: { all: "All (15)", balok: "Beams & Structural", papan: "Planks & Plywood", reng: "Battens & Rafters", outdoor: "Outdoor Specialists" },
      labels: { size: "Size", grade: "Grade", stock: "Stock" },
      ready: "Ready Stock",
      order: "Order via WA",
      detail: "View Details",
      orderMsg: (name, dim) => `Hello CV. Sinar Al Mubarokah, I'd like to order *${name}* size ${dim}. Please share pricing & stock availability.`,
    },
    keywords: {
      eyebrow: "PROCUREMENT KEYWORD HUB",
      title: "Looking for timber? We rank for these 10 keywords.",
      sub: "Click to copy a keyword, or ask its price directly on our WhatsApp.",
      copied: "Copied!",
      copy: "Copy",
      ask: "Ask Price",
      askMsg: (kw) => `Hello CV. Sinar Al Mubarokah, I'm searching for "${kw}". Please send your best quote.`,
      list: [
        "pabrik kayu jakarta murah",
        "distributor kayu olahan cilincing",
        "supplier kayu balok meranti jakarta",
        "jual kayu kamper samarinda grosir",
        "harga kaso 4x6 murah jakarta",
        "agen kayu bengkirai deck jabodetabek",
        "grosir plywood triplek cor jakarta utara",
        "distributor kayu ulin merbau partai besar",
        "tempat beli kayu proyek konstruksi terdekat",
        "custom ukuran kayu industri pallet langsung pabrik",
      ],
    },
    calculator: {
      eyebrow: "TIMBER VOLUME CALCULATOR",
      title: "Calculate your timber needs in seconds.",
      sub: "Enter dimensions & piece count — get instant m³ volume and a price estimate.",
      thickness: "Thickness (cm)",
      width: "Width (cm)",
      length: "Length (m)",
      qty: "Pieces",
      result: "Total Volume / m³",
      estimate: "Price Estimate",
      estimateNote: "Range of IDR 1,525,000 – 1,850,000 / m³, depending on wood species & grade.",
      ref: "Reference per 1 m³: kaso 4x6x4 ≈ 104 pcs · beams 6x12x4 ≈ 35 pcs",
      send: "Send Calculation to WhatsApp",
      waMsg: (t, w, l, q, v) => `Hello CV. Sinar Al Mubarokah, my calculation: ${t}x${w} cm, length ${l} m, ${q} pcs = ${v} m³. Please send a quote.`,
      tier: (v) => (v >= 5 ? "Price Tier: Bulk (lowest rate)" : v >= 1 ? "Price Tier: Wholesale" : "Price Tier: Project Retail"),
    },
    location: {
      eyebrow: "FACTORY & WAREHOUSE LOCATION",
      title: "Visit our factory in Cilincing in person.",
      sub: "Procurement teams are welcome to inspect the facility, check physical stock, and negotiate on-site.",
      address: "Jl. Kali Baru Bar. III No.41, RT.2/RW.12, Kali Baru, Cilincing, North Jakarta 14110",
      openMaps: "Open in Google Maps",
      hours: "Monday – Saturday, 08:00 – 17:00 WIB",
      fleet: "Fleet radius: Greater Jakarta • Banten • Karawang • National sea freight",
    },
    productPage: {
      back: "Back to Catalog",
      gallery: "Product Photo Gallery",
      spec: "Specifications & Size Table",
      size: "Available Sizes",
      grade: "Grade",
      mc: "Moisture Content",
      use: "Applications",
      stock: "Stock Status",
      stockValue: "Ready Stock — Cilincing Warehouse",
      minOrder: "Minimum Order",
      order: "Order This Product via WhatsApp",
      related: "Related Products",
      slideshowTitle: "Jakarta's Most Complete Timber",
      guideTitle: "Ordering & Delivery Process",
      guideIntro: "Ordering from CV. Sinar Al Mubarokah is designed to be fast and transparent for your project needs:",
      guideSteps: [
        "Send your requirements via WhatsApp at 0822-8280-0020 — mention the product, size, and number of pieces/sheets needed.",
        "Our team replies the same day with actual stock photos, current pricing, and delivery cost to your project site.",
        "Once agreed, payment can be made by bank transfer or cash at our warehouse. Greater Jakarta delivery is handled by our own fleet within 24 working hours.",
      ],
      guideNote: "You are also welcome to visit our warehouse at Jl. Kali Baru Bar. III No.41, Kali Baru, Cilincing, North Jakarta for physical stock inspection and direct bulk-price negotiation.",
    },
    blog: {
      eyebrow: "ARTICLES & GUIDES",
      title: "Timber procurement guides for your project.",
      sub: "Articles on wood species, price updates, and tips for buying direct from the factory — in Indonesian and English.",
      readMore: "Read Article",
      min: "min read",
      back: "All Articles",
      related: "More Articles",
      ctaTitle: "Need a price quote today?",
      ctaSub: "Our team responds fast — send your requirements and we'll reply with factory pricing.",
      ctaBtn: "Chat on WhatsApp Now",
      toc: "Table of Contents",
      byAuthor: "Written by",
    },
    footer: {
      tagline: "Jakarta processed wood factory & distributor. Abundant stock, all species & sizes, direct factory prices.",
      contact: "Contact",
      quick: "Navigation",
      rights: "All rights reserved.",
    },
    float: { online: "Online — Chat WhatsApp" },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("sam-lang") || "id");
  const setLang = (l) => {
    localStorage.setItem("sam-lang", l);
    setLangState(l);
  };
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
